import { useEffect, useRef, useCallback } from "react"

export function useTimeout() {
  const timeoutRef = useRef<number | null>(null)
  const callbackRef = useRef<() => void>()

  const set = useCallback((callback: () => void, delay = 0) => {
    callbackRef.current = callback

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }

    timeoutRef.current = window.setTimeout(() => {
      callbackRef.current?.()
      timeoutRef.current = null
    }, delay)
  }, [])

  const clear = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
      timeoutRef.current = null
    }
  }, [])

  // Cleanup on unmount
  useEffect(() => clear, [clear])

  return { set, clear }
}
